export { Logo } from './logo';
export { getLogoConfig } from './logo-config';
//# sourceMappingURL=index.js.map